<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    window.addEventListener('scroll', this.scrollFn)
  },
  methods: {
    scrollFn() {
      let header = document.getElementById('header')
      if (window.scrollY > 120) {
        header.classList.add('header-fixed')
      } else {
        header.classList.remove('header-fixed')
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue